import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'au-close-button',
	imports: [MatIconModule, MatButtonModule],
	templateUrl: './au-close-button.component.html',
	styleUrls: ['./au-close-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuCloseButtonComponent {
	closeCallback = output();
}
